import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import FormatUtils from '../common/formatUtils/FormatUtils';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import { setError } from '../common/toast/toast';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import SelectDefault from '../common/form/selectDefault';
import DateFormat from '../common/dateFormat/DateFormat';
import ColorUtils from '../common/colorUtils/ColorUtils';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import ButtonTable from '../common/table/buttonTable';
import consts from '../consts';

import {
	setModoTela, initForm
} from './setorActions';

class SetorForm extends Component {

	state = {

	}

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							{(!this.props.formularioValues.id || this.props.formularioValues.id_setor_pai) &&
							<Field
								name='id_setor_pai'
								options={this.props.listaSetor}
								component={Select}
								label='Setor'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={this.props.formularioValues.id ? 'readOnly' : readOnly} />}

							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome' placeholder='Informe o nome'
								cols='12 12 12 12'
								readOnly={this.props.formularioValues.id ? 'readOnly' : readOnly} />

							<Field
								name='abreviacao'
								component={LabelAndInput}
								label='Abreviação' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly} />

							<Select
								name='ids_usuarios'
								options={this.props.listaUsuario}
								label='Usuários'
								cols='12 12 12 12'
								placeholder='Selecione'
								multiple
								readOnly={readOnly}
								value={this.props.formularioValues.ids_usuarios}
								onChange={values => {
									this.props.initForm({
										...this.props.formularioValues,
										ids_usuarios: values.map(item => item.value)
									});
								}} />

							<Select
								name='ids_usuarios_supervisores'
								options={this.props.listaUsuario}
								label='Supervisores'
								cols='12 12 12 12'
								placeholder='Selecione'
								multiple
								readOnly={readOnly}
								value={this.props.formularioValues.ids_usuarios_supervisores}
								onChange={values => {
									this.props.initForm({
										...this.props.formularioValues,
										ids_usuarios_supervisores: values.map(item => item.value)
									});
								}} />

							<Select
								name='ids_usuarios_gestores'
								options={this.props.listaUsuario}
								label='Gestores'
								cols='12 12 12 12'
								placeholder='Selecione'
								multiple
								readOnly={readOnly}
								value={this.props.formularioValues.ids_usuarios_gestores}
								onChange={values => {
									this.props.initForm({
										...this.props.formularioValues,
										ids_usuarios_gestores: values.map(item => item.value)
									});
								}} />
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
									<Button
										text='Salvar'
										submit
										type={'success'}
										icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
	}

}

SetorForm = reduxForm({ form: 'setorForm', destroyOnUnmount: false })(SetorForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('setorForm')(state),
	registro: state.setor.registro,
	listaUsuario: state.setor.listaUsuario,
	listaSetor: state.setor.listaSelect.filter(item => !item.id_setor_pai)
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(SetorForm);